/** Visible and screen-reader friendly feedback while an action is in flight. */
export function ActionStatus({ children }: { children: string }) {
  return <span className="action-status" role="status"><span className="action-spinner" aria-hidden="true" />{children}</span>;
}
